import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../../services/api";

function AuthenticatedRoute() {
    if (isAuthenticated())
        return <Navigate to="/" replace />;

    return <Outlet />;
}

export default AuthenticatedRoute;